import { Button, TextField } from '@material-ui/core';
import React, { createRef } from 'react';
import Media from 'react-media';
import { Route } from 'react-router-dom';
import { HeaderDesktop } from '../../../components/header/desktop/HeaderDesktop';
import { HeaderMobile } from '../../../components/header/mobile/HeaderMobile';
import FolderIcon from '../../../resources/wrappers/FolderIcon';
import { GoogleTagManagerService } from '../../../services/analitycs/GoogleTagManagerService';
import './InsertProductDetails.css';
import $ from 'jquery';
import { AppUtils } from '../../../utils/AppUtils';
import { ImageCropper } from '../../../components/cropper/ImageCropper';
import TrashIcon from '../../../resources/wrappers/TrashIcon';
import { ImageViewer } from '../../../components/image-viewer/ImageViewer';
import { IProductDto, ProductDto } from '../../../models/ProductDto';
import { MposWebPortalApi } from '../../../services/api/MposWebPortalApi';
import { CurrencyUtils } from '../../../utils/CurrencyUtils';
import { dataStore } from '../../../services/storage/DataStore';

export class InsertProductDetails extends React.Component<any, any> {
    readonly MAX_PRODUCT_NAME_LENGTH: number = 30;
    readonly MAX_PRODUCT_DESCRIPTION_LENGTH: number = 80;

    productNameInputRef: any;
    productDescriptionRef: any;
    productPriceRef: any;
    inputFileRef: any;
    constructor(props: any){
        super(props);
        this.state = {
            productName: "",
            productDescription: "",
            productPrice: "",
            fileLoaded: false,
            fileValid: true,
            fileTypeError: false,
            fileSizeError: false,
            fileGenericError: false,
            fileInput: undefined,
            fileName: "",
            fileType: "",
            nameRemainingLength: this.MAX_PRODUCT_NAME_LENGTH,
            descriptionRemainingLength: this.MAX_PRODUCT_DESCRIPTION_LENGTH,
            buttonNextDisabled: true,
            showImageCropDialog: false,
            imageCropped: "",
            insertProduct: "",
            changeProduct: "",
            showImageViewer: false,
            isUpdate: false,
            toUpdate: null,
            pathToReturn: "/catalog"
        }

        this.handleProductNameChanges = this.handleProductNameChanges.bind(this);
        this.handleProductNameKeyDown = this.handleProductNameKeyDown.bind(this);
        this.productNameInputRef = createRef();
        this.handleProductDescriptionChanges = this.handleProductDescriptionChanges.bind(this);
        this.handleProductDescriptionKeyDown = this.handleProductDescriptionKeyDown.bind(this);
        this.productDescriptionRef = createRef();

        this.handleProductPriceKeyDown = this.handleProductPriceKeyDown.bind(this);
        this.productPriceRef = createRef();
        this.handlePriceKeyPress = this.handlePriceKeyPress.bind(this);
        this.handlePriceKeyUp = this.handlePriceKeyUp.bind(this);
        this.handlePriceChanges = this.handlePriceChanges.bind(this);

        this.inputFileRef = createRef();
        this.handleFileSelected = this.handleFileSelected.bind(this);
        this.handleFileContainerClick = this.handleFileContainerClick.bind(this);
    }

    componentDidMount(){
        GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'catalogo prodotti: creazione prodotto: inserimento dati');
        this.setState({insertProduct: true});
        this.setState({changeProduct: false});
        if(this.props.location.state !== undefined){
            const { data } = this.props.location.state;
            if(data !== undefined){
                if(data.update){
                    this.setState({isUpdate: true})
                    let pathToReturn = data.pathToReturn;
                    if(pathToReturn !== undefined){
                        this.setState({pathToReturn: pathToReturn});
                    }
                    let toUpdate: IProductDto = data.product;
                    this.setState({toUpdate: toUpdate});
                    this.setState({productName: (toUpdate.name !== null && toUpdate.name !== undefined) ? toUpdate.name : ""}, () => {
                        let computedLength = this.MAX_PRODUCT_NAME_LENGTH - this.state.productName.length;
                        this.setState({nameRemainingLength: computedLength}, () => {
                            this.checkIfButtonNextMustBeDisabled();
                        });
                    });
                    this.setState({productDescription: (toUpdate.descr !== null && toUpdate.descr !== undefined) ? toUpdate.descr : ""}, () => {
                        let computedLength = this.MAX_PRODUCT_DESCRIPTION_LENGTH - this.state.productDescription.length;
                        this.setState({descriptionRemainingLength: computedLength});
                    });
                    this.setState({productPrice: (parseFloat(toUpdate.amount!)/100).toLocaleString('it-IT', {
                        style: 'currency',
                        currency: 'EUR',
                    })});
                    this.setState({fileName: toUpdate.imageName});
                    this.setState({imageCropped: toUpdate.image}, () => {
                        if(this.state.imageCropped !== undefined && this.state.imageCropped !== null && this.state.imageCropped !== ""){
                            this.setState({fileValid: true});
                            this.setState({fileLoaded: true});
                        }
                    });
                    this.setState({imageName: toUpdate.imageName});
                    this.setState({fileType: toUpdate.imageType});
                }
            }
        } else {
            let dataFromStore = this.props.dataCached;
            if(dataFromStore !== undefined){
                this.setState({productName: dataFromStore.productName});
                this.setState({productDescription: dataFromStore.productDescription});
                this.setState({productPrice: CurrencyUtils.formatValue(parseInt(dataFromStore.productPrice))});
                this.setState({fileName: dataFromStore.imageName});
                this.setState({fileType: dataFromStore.imageType});
                if(dataFromStore.image !== null && dataFromStore.image !== undefined && dataFromStore.image !== ""){
                    console.log("Image available...")
                    let header = "data:" + dataFromStore.imageType + ";base64,";
                    let image = header + dataFromStore.image;
                    console.log(image);
                    this.setState({ImageCropped: image}, () => {
                        this.setState({fileValid: true});
                        this.setState({fileLoaded: true});
                    });
                }
                this.setState({buttonNextDisabled: false});
            }
        }

        window.scrollTo(0, 0);
    }

    private goToChooseCategories(history: any){
        let data = {
            productName: this.state.productName,
            productDescription: this.state.productDescription !== undefined ? this.state.productDescription : "",
            productPrice: parseInt(this.state.productPrice.replace(/[.,€\s]/g, '')).toString(),
            imageName: this.state.fileName,
            imageType: this.state.fileType,
            image: this.state.imageCropped !== undefined ? this.state.imageCropped.split(',')[1] : ""
        }
        dataStore.tryToInsertProductData(data);
        history.push('/addProduct/categories', {data: data});
    }

    private handleProductNameChanges(event: any){
        // Android workaround, Google Chrome not support well input type max lenght
        if(event.target.value.length > this.MAX_PRODUCT_NAME_LENGTH){
            event.preventDefault();
        } else {
            this.setState({productName: event.target.value});
            let computedLength = this.MAX_PRODUCT_NAME_LENGTH - event.target.value.length;
            this.setState({nameRemainingLength: computedLength}, () => {
                this.checkIfButtonNextMustBeDisabled();
            });
        }
    }

    private handleProductNameKeyDown(event: any){
        if(AppUtils.isPhoneOrTablet()){
            if (event.key === 'Enter') {
                console.log("[InsertProductDetails] Done clicked!");
                if(this.productNameInputRef !== undefined){
                    this.productNameInputRef.current.blur();
                }
            }
        }
    }

    private handleProductDescriptionChanges(event: any){
        // Android workaround, Google Chrome not support well input type max lenght
        if(event.target.value.length > this.MAX_PRODUCT_DESCRIPTION_LENGTH){
            event.preventDefault();
        } else {
            this.setState({productDescription: event.target.value});
            let computedLength = this.MAX_PRODUCT_DESCRIPTION_LENGTH - event.target.value.length;
            this.setState({descriptionRemainingLength: computedLength});
        }
    }

    private handleProductDescriptionKeyDown(event: any){
        if(AppUtils.isPhoneOrTablet()){
            if (event.key === 'Enter') {
                console.log("[InsertProductDetails] Done clicked!");
                if(this.productDescriptionRef !== undefined){
                    this.productDescriptionRef.current.blur();
                }
            }
        }
    }

    private handleFileSelected(event: any){
        const fileUploaded = event.target.files[0];
        if(fileUploaded !== undefined){
            let mimeType = fileUploaded.type;
            let fileSize = fileUploaded.size;
            let fileName = fileUploaded.name;
            // Validating file type and dimensions
            if(fileSize !== 0){
                if(mimeType === 'image/png' || mimeType === 'image/jpeg'){
                    let fileSizeInMiB = fileSize / 1024 / 1024;
                    if(fileSizeInMiB < 5){
                        this.setState({fileValid: true});
                        this.setState({fileTypeError: false});
                        this.setState({fileSizeError: false});
                        this.setState({fileGenericError: false});
                        this.setState({fileInput: fileUploaded}, () => {
                            this.setState({fileName: fileName});
                            this.setState({fileType: mimeType});
                            this.setState({showImageCropDialog: true});
                        });
                    } else {
                        this.setState({fileValid: false});
                        this.setState({fileTypeError: false});
                        this.setState({fileSizeError: true});
                        this.setState({fileGenericError: false});
                        this.setState({fileName: ""});
                    }
                } else {
                    this.setState({fileValid: false});
                    this.setState({fileTypeError: true});
                    this.setState({fileSizeError: false});
                    this.setState({fileGenericError: false});
                    this.setState({fileName: ""});
                }
            } else {
                this.setState({fileValid: false});
                this.setState({fileTypeError: false});
                this.setState({fileSizeError: false});
                this.setState({fileGenericError: true});
                this.setState({fileName: ""});
            }
        }
    }

    private handleFileContainerClick(){
        this.setState({fileValid: true});
        this.setState({fileTypeError: false});
        this.setState({fileSizeError: false});
        this.setState({fileGenericError: false});
        this.setState({fileInput: undefined});
        this.inputFileRef.current.click();
    }

    private hideHelperText(input: string){
        $('#' + input).css('visibility', 'hidden');
    }

    private showHelperText(input: string){
        $('#' + input).css('visibility', 'visible');
    }

    private checkIfButtonNextMustBeDisabled(){
        // Check product name
        if(this.state.productName.length > 0){
            // Check price 
            if(this.state.productPrice.length > 0){
                let intVal = CurrencyUtils.getIntVal(this.state.productPrice);
                if(intVal === 0){
                    this.setState({buttonNextDisabled: true});
                } else {
                    this.setState({buttonNextDisabled: false});
                }
            } else {
                this.setState({buttonNextDisabled: true});
            }
        } else {
            this.setState({buttonNextDisabled: true});
        }
    }

    private deleteImage(){
        this.setState({fileValid: true});
        this.setState({fileTypeError: false});
        this.setState({fileSizeError: false});
        this.setState({fileGenericError: false});
        this.setState({fileInput: undefined});
        this.setState({fileName: ""});
        this.setState({imageCropped: ""});
        this.setState({fileLoaded: false});
    }

    private showLoadedImage(){
        this.setState({showImageViewer: true});
    }

    private hideLoadedImage() {
        this.setState({showImageViewer: false});
    }

    private resetAmountIfZero(){
        let intVal = CurrencyUtils.getIntVal(this.state.productPrice);
        if(intVal === 0){
            this.setState({productPrice: ""}, () => {
                this.checkIfButtonNextMustBeDisabled();
            })
        }
    }

    private sanitizeImage(imageUrl: string){
        if(imageUrl.includes(',')){
            return imageUrl.split(',')[1];
        } else {
            return imageUrl;
        }
    }

    private updateProduct(history: any){
        let old: IProductDto = this.state.toUpdate;
        let productDto = new ProductDto(this.state.productPrice.replace(/[.,€\s]/g, ''), old.categories, this.state.productDescription !== undefined ? this.state.productDescription : null, 
        (this.state.imageCropped !== undefined && this.state.imageCropped !== null && this.state.imageCropped !== "") ? this.sanitizeImage(this.state.imageCropped) : null, 
        (this.state.imageCropped !== undefined && this.state.imageCropped !== null && this.state.imageCropped !== "") ? this.state.fileType : null, 
        this.state.productName, old.productId, 
        (this.state.imageCropped !== undefined && this.state.imageCropped !== null && this.state.imageCropped !== "") ? this.state.fileName : null, 
        old.lastUpdate);
        MposWebPortalApi.getInstance().updateProduct(productDto).subscribe((result) => {
            if(result){
                this.setState({showLoader: false});
                history.push('/result', {
                    isSuccess: true,
                    title: "Hai modificato le informazioni del tuo prodotto!",
                    message: "",
                    button: "TORNA AL PRODOTTO",
                    data: { from: "InsertProductDetails", operation: "updateProduct", product: productDto }
                })
            } else {
                // show error page
                this.setState({showLoader: false});
                history.push('/result', {
                    isSuccess: false,
                    errorTitle: "Si è verificato un errore durante la modifica delle informazioni del prodotto.",
                    message: "Riprova più tardi. Grazie per la pazienza",
                    button: "TORNA AL PRODOTTO",
                    data: { from: "InsertProductDetails", operation: "updateProduct", product: productDto }
                })
            }
        }, (error) => {
            // show error page
            this.setState({showLoader: false});
            history.push('/result', {
                isSuccess: false,
                errorTitle: "Si è verificato un errore durante la modifica delle informazioni del prodotto.",
                message: "Riprova più tardi. Grazie per la pazienza",
                button: "TORNA AL PRODOTTO",
                data: { from: "InsertProductDetails", operation: "updateProduct", product: productDto }
            })
        });
    }

    private getBase64Image(): string {
        let imageType = this.state.fileType;
        if(imageType === undefined){
            imageType = 'image/jpeg';
        }
        return "data:" + this.state.fileType + ";base64," + this.state.imageCropped;
    }

    // Amount management

    private productPriceFocus(event: any){
        let intVal = CurrencyUtils.getIntVal(this.state.productPrice);
        this.setState({productPrice: CurrencyUtils.formatValue(intVal)}, () => {
            this.checkIfButtonNextMustBeDisabled();
        });
    }

    private handlePriceChanges(event: any){
        // ONLY FOR ANDROID 
        if(AppUtils.isAndroid()){
            // Check if delete
            if(event.nativeEvent.inputType === 'deleteContentBackward'){
                // Is deletion
                let length = this.state.productPrice.length;
                event.target.setSelectionRange(length,length);
                let replaced = this.state.productPrice.replace(/[.,€\s]/g, '');
                replaced = replaced.substring(0, replaced.length - 1);
                let intVal = CurrencyUtils.getIntVal(replaced);
                this.setState({productPrice: CurrencyUtils.formatValue(intVal)}, () => {
                    this.checkIfButtonNextMustBeDisabled();
                });
            } else {
                // Not is deletion
                if(/^[0-9]+$/.test(event.target.value.replace(/[.,€\s]/g, ''))){
                    let intVal = CurrencyUtils.getIntVal(this.state.productPrice);
                    let diff = this.diffBetweenInputs(this.state.productPrice.replace(/[.,€\s]/g, ''), event.target.value.replace(/[.,€\s]/g, ''));
                    let add = parseInt(diff);
                    intVal = (intVal * 10) + add;
                    if(intVal <= 9999999){
                        this.setState({productPrice: CurrencyUtils.formatValue(intVal)}, () => {
                            this.checkIfButtonNextMustBeDisabled();
                        });
                    } else {
                        event.preventDefault();
                    }
                } else {
                    event.preventDefault();
                }
            }
        } else {
            event.preventDefault();
        }
    }

    private diffBetweenInputs(a: string, b: string){
        let i = 0;
        let j = 0;
        let result = "";
        
        while (j < b.length)
        {
            if (a[i] != b[j] || i == a.length)
                result += b[j];
            else
                i++;
            j++;
        }
        return result;
    }

    private handlePriceKeyPress(event: any) {
        if(!AppUtils.isAndroid()){
            // Only digits are allowed
            if(event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57)){
                event.preventDefault();
            } else {
                let intVal = CurrencyUtils.getIntVal(this.state.productPrice);
                if(event.which === 0 || event.which === 8){
                    // Nothing to do
                } else {
                    // map char to number
                    let add = parseInt(String.fromCharCode(event.which));
                    intVal = (intVal * 10) + add;
                    if(intVal <= 9999999){
                        this.setState({productPrice: CurrencyUtils.formatValue(intVal)}, () => {
                            this.checkIfButtonNextMustBeDisabled();
                        });
                    } else {
                        event.preventDefault();
                    }
                }
            }
        } else {
            event.preventDefault();
        }
    }

    private handlePriceKeyUp(event: any) {
        if(!AppUtils.isAndroid()){
            // Android doesn't support keypress, use keyup instead, but not manage logic here
            if(event.which === 8 || event.which === 0){
                let replaced = this.state.productPrice.replace(/[.,€\s]/g, '');
                replaced = replaced.substring(0, replaced.length - 1);
                let intVal = CurrencyUtils.getIntVal(replaced);
                this.setState({productPrice: CurrencyUtils.formatValue(intVal)}, () => {
                    this.checkIfButtonNextMustBeDisabled();
                });
            }
        } else {
            event.preventDefault();
        }
    }

    private handleProductPriceKeyDown(event: any){
        if(AppUtils.isPhoneOrTablet()){
            if (event.key === 'Enter') {
                console.log("[InsertProductDetails] Done clicked on amount!");
                if(this.productPriceRef !== undefined){
                    this.productPriceRef.current.blur();
                }
            }
        }
    }

    render(){
        return [
            !(this.state.showImageCropDialog) && <div id={"main-container-insert-product-details"}>
                <Media query="(max-width: 1064px)" render={() =>  {
                    return (
                        <HeaderMobile showBack={true} showLogout={false} showTitle={true} title={this.state.isUpdate ? "Modifica prodotto" : "Crea prodotto"} showClose={this.state.isUpdate ? false : true} 
                        closePage={this.state.isUpdate ? this.state.pathToReturn : '/catalog'} returnState={{image: this.state.imageCropped, type: this.state.fileType}}/>);
                }}/>
                <Media query="(min-width: 1065px)" render={() => {
                    return (
                        <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={this.state.isUpdate ? "Modifica prodotto" : "Crea prodotto"} showClose={this.state.isUpdate ? false : true}
                        closePage={this.state.isUpdate ? this.state.pathToReturn : '/catalog'} returnState={{image: this.state.imageCropped, type: this.state.fileType}}/>);
                }}/>
                <div id={"insert-product-details-content"}>
                    <form className={"insert-product-form-container"}>
                        <p className={"insert-product-details-title"}>Inserisci i dati del prodotto</p>
                        <div className={"insert-product-details-form-fields"}>
                                <TextField id={"insert-product-name-field"} label="Nome prodotto" type={"text"}
                                    onChange={this.handleProductNameChanges}
                                    onKeyDown={this.handleProductNameKeyDown}
                                    inputRef={this.productNameInputRef}
                                    value={this.state.productName} inputProps={{ maxLength: this.MAX_PRODUCT_NAME_LENGTH }}
                                    helperText={"-" + this.state.nameRemainingLength}
                                    onFocus={() => this.showHelperText('insert-product-name-field-helper-text')}
                                    onBlur={() => this.hideHelperText('insert-product-name-field-helper-text')}
                                    />
                                <TextField id={"insert-product-description-field"} label="Descrizione (Opzionale)" type={"text"}
                                    onChange={this.handleProductDescriptionChanges}
                                    onKeyDown={this.handleProductDescriptionKeyDown}
                                    inputRef={this.productDescriptionRef}
                                    value={this.state.productDescription} inputProps={{ maxLength: this.MAX_PRODUCT_DESCRIPTION_LENGTH }}
                                    helperText={"-" + this.state.descriptionRemainingLength}
                                    onFocus={() => this.showHelperText('insert-product-description-field-helper-text')}
                                    onBlur={() => this.hideHelperText('insert-product-description-field-helper-text')}
                                    multiline
                                    rows={3}
                                    />
                                <TextField id={"insert-product-price-field"} label="Prezzo (compreso IVA)" type={"text"}
                                    onKeyDown={this.handleProductPriceKeyDown}
                                    onKeyPress={this.handlePriceKeyPress}
                                    onKeyUp={this.handlePriceKeyUp}
                                    onChange={this.handlePriceChanges}
                                    inputRef={this.productPriceRef}
                                    onFocus={(event) => this.productPriceFocus(event)}
                                    onBlur={() => this.resetAmountIfZero()}
                                    value={this.state.productPrice}/>
                                <div className={"insert-product-row"}></div>
                                <p className={"insert-product-image-title"}>Carica l'immagine del prodotto (opzionale)</p>
                                {
                                    !this.state.fileLoaded ? <div className={this.state.fileValid ? "insert-product-file-not-loaded-container" : "insert-product-image-box-error"} onClick={this.handleFileContainerClick}>
                                        <input type="file" style={{display: 'none'}} ref={this.inputFileRef} onChange={this.handleFileSelected}/>
                                        <div className={"insert-product-file-not-loaded-image-container"}>
                                            <div className={"insert-product-file-not-loaded-folder-container"}>
                                                <FolderIcon width={'30px'} height={'25px'} fill={'#9596AF'} />
                                            </div>
                                        </div>
                                        <div className={"insert-product-file-not-loaded-text-container"}>
                                            <p className={"insert-product-image-text1"}>AGGIUNGI IMMAGINE</p>
                                            {
                                                !AppUtils.isPhoneOrTablet() ? <p className={"insert-product-image-text2"}>Clicca qui per caricare il file.<br/>Dimensione max 5 MB formato png e jpeg.</p> :
                                                <p className={"insert-product-image-text2"}>Clicca qui per caricare il file. Dimensione max 5 MB formato png e jpeg.</p>
                                            }
                                        </div>
                                    </div> :  <div className={"insert-product-file-loaded-content"}>
                                        <p className={"insert-product-file-name"} onClick={() => this.showLoadedImage()}>{this.state.fileName}</p>
                                        <div className={"insert-product-trash-icon"} onClick={() => this.deleteImage()}>   
                                            <TrashIcon width={'25px'} height={'25px'} fill={'#F9423A'}/>
                                        </div>
                                    </div>
                                }
                                {
                                    AppUtils.isPhoneOrTablet() ? [this.state.fileTypeError && <div className={"insert-product-error-text-container"}><p className={"insert-product-error-text"}>File non valido. Hai inserito un file con formato non corretto.</p></div>, 
                                    this.state.fileSizeError && <div className={"insert-product-error-text-container"}><p className={"insert-product-error-text"}>File non valido. Hai inserito un file di dimensioni maggiori al consentito.</p></div>,
                                    this.state.fileGenericError && <div className={"insert-product-error-text-container"}><p className={"insert-product-error-text"}>Caricamento fallito. Riprova.</p></div>] 
                                    : [this.state.fileTypeError && <div className={"insert-product-error-text-container"}><p className={"insert-product-error-text"}>File non valido.<br/>Hai inserito un file con formato non corretto.</p></div>, 
                                    this.state.fileSizeError && <div className={"insert-product-error-text-container"}><p className={"insert-product-error-text"}>File non valido. <br/>Hai inserito un file di dimensioni maggiori al consentito.</p></div>,
                                    this.state.fileGenericError && <div className={"insert-product-error-text-container"}><p className={"insert-product-error-text"}>Caricamento fallito. Riprova.</p></div>]
                                }
                                <div className={"insert-product-button-next-container"}>
                                    <Route render={({history}) => {
                                        return <Button id={"insert-product-button-next"} disabled={this.state.buttonNextDisabled} onClick={() => {
                                            this.state.isUpdate ? this.updateProduct(history) : this.goToChooseCategories(history);
                                        }}>{this.state.isUpdate ? "CONFERMA" : "AVANTI"}</Button>;
                                    }}/>
                                </div>
                        </div>
                    </form>
                </div>
            </div>,
            this.state.showImageCropDialog && <ImageCropper closeFunctionWithResult={(result: any) => {
                console.log("[From imageCropper] result is " + {...result});
                this.setState({showImageCropDialog: !this.state.showImageCropDialog});
                if(result.result === true){
                    let data = result.image;
                    this.setState({imageCropped: data});
                    this.setState({fileLoaded: true});
                }
            }} input={this.state.fileInput} />,
            this.state.showImageViewer && <ImageViewer imageSrc={this.state.isUpdate ? this.getBase64Image() : this.state.imageCropped} closeFunction={() => {
                this.hideLoadedImage();
            }}/>
        ]
    }
}